(function () {
  $(function() {
    $(".js-voiceAccordion").on("click", function(){
      $(this).toggleClass("is-active");
    });
  });
})();